<template>
	<div class="recharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()" />
			<div class="big_tit">
				{{ $t('account.manage') }}
			</div>
		</div>
		<div class="wrap_box warp1">
			<p><span>{{ allNum }}</span> {{ $t('account.withdrawalAccounts') }}</p>
		</div>
		<div class="wrap_box warp2">
			<div v-for="i in data.bank" class="item">
				<img :src="require('../images/user/recharge'+i.type+'.png')" alt="">
				<div class="item_detail">
					<p class="user_name ari_font">
						{{ i.type == 4?i.area:i.bank }}
					</p>
					<p class="holder_name">
						{{ i.name }}
					</p>
					<p class="user_num">
						{{ i.account }}
					</p>
				</div>
				<div class="del" @click="delCard(i.id)" style="display: none;" />
			</div>
		</div>

		<!-- 修改按钮显示逻辑 -->
		<div v-if="showSpecificButton && !hasBoundType(specificType)" class="basic_btn"
			@click="goToAddPage(specificType)">
			{{ specificButtonText }}
		</div>

		<div class="tip_box">
			<div class="tip_icon">!</div>
			<div class="tip_text">每个钱包只能绑定一次（即银行卡、支付宝各绑定一次）<br />更换请联系客服</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch'

	export default {
		name: "Account",
		data() {
			return {
				allNum: 0,
				data: {},
				showSpecificButton: false,
				specificType: null,
				boundTypes: [] // 存储已绑定的账户类型
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
			this.checkRouteParams();
		},
		computed: {
			specificButtonText() {
				switch (this.specificType) {
					case 4:
						return "绑定银行卡";
					case 2:
						return "绑定支付宝";
					case 1:
						return "绑定USDT";
					case 3:
						return "绑定微信";
					default:
						return "绑定钱包";
				}
			}
		},
		methods: {
			// 检查是否已绑定某种类型的账户
			hasBoundType(type) {
				return this.boundTypes.includes(type);
			},

			checkRouteParams() {
				// 检查路由参数，判断是从哪个入口进入的
				const routeQuery = this.$route.query;
				if (routeQuery.from === 'bank' || routeQuery.type === '4') {
					this.showSpecificButton = true;
					this.specificType = 4; // 银行卡
				} else if (routeQuery.from === 'alipay' || routeQuery.type === '2') {
					this.showSpecificButton = true;
					this.specificType = 2; // 支付宝
				} else if (routeQuery.from === 'usdt' || routeQuery.type === '1') {
					this.showSpecificButton = true;
					this.specificType = 1; // USDT
				} else if (routeQuery.from === 'wechat' || routeQuery.type === '3') {
					this.showSpecificButton = true;
					this.specificType = 3; // 微信
				} else {
					this.showSpecificButton = false;
				}
			},
			goToAddPage(type) {
				this.$router.push('/addcountUsdt?type=' + type);
			},
			delCard(id) {
				Fetch('/user/bank_remove', {
					id: id
				}).then(() => {
					this.start()
				});
			},
			start() {
				Fetch('/user/my_bank').then(r => {
					this.data = r.data;
					this.allNum = r.data.count;

					// 提取已绑定的账户类型
					this.boundTypes = r.data.bank.map(item => item.type);
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
	}

	.back_left {
		background: url(../../views/images/item/back_b.png) no-repeat center center;
	}

	.big_tit {
		color: #FFF;
	}

	/* 添加提示框样式 */
	.tip_box {
		display: flex;
		align-items: flex-start;
		background: #FFF9E6;
		border: 1px solid #FFE58F;
		border-radius: 4px;
		padding: 10px 15px;
		margin: 20px 15px 0 15px;
	}

	.tip_icon {
		width: 16px;
		height: 16px;
		background: #FAAD14;
		border-radius: 50%;
		color: #FFF;
		font-size: 12px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 8px;
		flex-shrink: 0;
		margin-top: 1px;
	}

	.tip_text {
		font-size: 12px;
		color: #8A6D3B;
		line-height: 1.4;
	}

	.warp1 {
		padding: 0 20px;
		height: 40px;

		p {
			font-size: 14px;
			line-height: 40px;
			color: rgba(0, 0, 0, .8);
			font-weight: bold;

			span {
				color: #F03041;
			}
		}
	}

	.ari_font {
		height: 20px;
		font-size: 14px;
		font-weight: 600;
		color: rgba(0, 0, 0, .8);
		line-height: 20px;
	}

	.holder_name {
		height: 17px;
		font-size: 12px;
		font-weight: 600;
		color: rgba(0, 0, 0, .7);
		line-height: 17px;
		margin-top: 5px;
	}

	.warp2 {
		padding: 0 15px;
		margin-top: 12px;

		.item {
			padding: 14px 0 11px 0;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			border-bottom: 1px solid #ECECEC;

			&:last-child {
				border-bottom: none;
			}

			img {
				width: 30px;
				height: 30px;
			}

			.item_name {
				width: 65px;
			}

			.item_detail {
				margin-left: 10px;
			}

			.user_num {
				height: 17px;
				font-size: 12px;
				font-weight: 600;
				color: rgba(0, 0, 0, .6);
				line-height: 17px;
				margin-top: 10px;
			}

			.del {
				width: 20px;
				height: 20px;
				background: url(../images/item/del.png) no-repeat center center;
				background-size: 100% 100%;
				margin: 0 8px 0 auto;
			}
		}
	}

	.basic_btn {
		margin: 50px auto 0 auto;
	}

	/* 添加按钮组样式 */
	.btn-group {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;
		margin: 50px 20px 0 20px;
	}

	.btn-group .basic_btn {
		width: 100%;
		margin: 0;
	}
</style>